<template>
  <b-modal id="family-modal-detail" ref="modal" size="lg" title="Detail" @show="setData" @hidden="resetModal">
    <b-form >
      <div class="row">
        <!-- grid column -->
        <div class="col-lg-12">
          <!-- .card -->
          <div class="card card-fluid">
            <!-- .card-body -->
            <div class="card-body">
              <div class="form-row">
                <label class="col-md-3">Relationship Type</label>
                <div class="col-md-8 mb-3">
                  {{detail.relation_type_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Relationship Status</label>
                <div class="col-md-8 mb-3">
                  {{detail.relation_status_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Name</label>
                <div class="col-md-8 mb-3">
                  {{detail.family_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Nick Name</label>
                <div class="col-md-8 mb-3">
                  {{detail.family_nick_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Title</label>
                <div class="col-md-8 mb-3">
                  {{detail.salutation_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Academic Title (Prefix)</label>
                <div class="col-md-8 mb-3">
                  {{detail.family_title_prefix}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Academic Title (Suffix)</label>
                <div class="col-md-8 mb-3">
                  {{detail.family_title_sufix}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Gender</label>
                <div class="col-md-8 mb-3">
                  {{detail.family_gender == "m" ? "Male":"Female"}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Place of Birth</label>
                <div class="col-md-8 mb-3">
                  {{detail.family_birth_place}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Birth Date</label>
                <div class="col-md-8 mb-3">
                  {{detail.family_birth_date}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Religion</label>
                <div class="col-md-8 mb-3">
                  {{detail.family_religion_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Nationality</label>
                <div class="col-md-8 mb-3">
                  {{detail.nationality_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Blood Type</label>
                <div class="col-md-8 mb-3">
                  {{detail.bloodtype_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Address</label>
                <div class="col-md-8 mb-3">
                  {{detail.address}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Country</label>
                <div class="col-md-8 mb-3">
                  {{detail.country_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">State</label>
                <div class="col-md-8 mb-3">
                  {{detail.state_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">City</label>
                <div class="col-md-8 mb-3">
                  {{detail.city_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Email</label>
                <div class="col-md-8 mb-3">
                  {{detail.family_email}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Phone Number</label>
                <div class="col-md-8 mb-3">
                  {{detail.phone}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Mobile Phone Number</label>
                <div class="col-md-8 mb-3">
                  {{detail.mobile}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">ID Number</label>
                <div class="col-md-8 mb-3">
                  {{detail.id_number}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-form>
    <template v-slot:modal-footer>
      <div class="w-100">
        <button class="btn btn-secondary float-right" @click="resetModal"> Cancel </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {BModal, BForm} from 'bootstrap-vue'
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";
export default {
  name: "FamilyDetail",
  components:{
    BModal,
    BForm
  },
  props:{
    id:{
      type:Number
    }
  },
  data(){
    return {
      detail:{
        relation_type_name:"",
        relation_status_name:"",
        family_name:"",
        family_nick_name:"",
        salutation_name:"",
        family_title_prefix:"",
        family_title_sufix:"",
        family_birth_place:"",
        family_birth_date:"",
        family_religion_name:"",
        nationality_name:"",
        bloodtype_name:"",
        address:"",
        country_name:"",
        state_name:"",
        city_name:"",
        family_email:"",
        phone:"",
        mobile:"",
        id_number:""
      }
    }
  },
  methods:{
    setData(){
      setTimeout(()=>{
        if(this.id !== null){
            this.getDetail()
        }
      }, 100)
    },
    resetModal(){
      this.$parent.id = null
      this.detail = {
        relation_type_name:"",
        relation_status_name:"",
        family_name:"",
        family_nick_name:"",
        salutation_name:"",
        family_title_prefix:"",
        family_title_sufix:"",
        family_birth_place:"",
        family_birth_date:"",
        family_religion_name:"",
        nationality_name:"",
        bloodtype_name:"",
        address:"",
        country_name:"",
        state_name:"",
        city_name:"",
        family_email:"",
        phone:"",
        mobile:"",
        id_number:""
      }
      this.$refs.modal.hide()
    },
    getDetail(){
      let payload = {id:this.id}

      AxiosCall.Get(payload, urlApi.family.detail).then(res=>{
        if(res.success){
          let data = res.atributes
          this.detail = {
            relation_type_name:data.relation_type_name,
            relation_status_name:data.relation_status_name,
            family_name:data.family_name,
            family_nick_name:data.family_nick_name,
            salutation_name:data.salutation_name,
            family_title_prefix:data.family_title_prefix,
            family_title_sufix:data.family_title_sufix,
            family_birth_place:data.family_birth_place,
            family_birth_date:data.family_birth_date,
            family_religion_name:data.religion_name,
            nationality_name:data.citizenship_name,
            bloodtype_name:data.bloodtype_name,
            address:data.address,
            country_name: data.country_name,
            state_name: data.state_name,
            city_name: data.city_name,
            family_email:data.family_email,
            phone:data.phone_numb,
            mobile:data.mobile_phone_numb,
            id_number:data.id_number
          }
        }else{
          this.$parent.errorMessage(res.message)
        }
      }).catch(e=>{
        this.$parent.errorMessage(e.response.data.message)
      })
    }
  }
}
</script>